/**
 * White-label client/org strings for the browser bundle.
 *
 * Create React App only inlines env vars prefixed with REACT_APP_.
 * Prefer FRONTEND_CLIENT_NAME in root `.env` or `backend/.env` (npm start merges backend via
 * `scripts/cra-with-backend-branding.cjs`, mapping FRONTEND_* → REACT_APP_* for CRA).
 * If unset, BACKEND_CLIENT_NAME (or legacy CLIENT_NAME)
 * in backend/.env is mapped (CREIGHTON → "Creighton Bluejays"; other ALL_CAPS → Title Case).
 *
 * Optional: FRONTEND_STAFF_EMAIL_DOMAIN (mapped to REACT_APP_STAFF_EMAIL_DOMAIN) for login placeholder.
 */

function trimStr(v) {
  if (v == null) return '';
  return String(v).trim();
}

/** Raw display name from build-time env (mapped from FRONTEND_CLIENT_NAME). */
export function getClientDisplayName() {
  const fromReact = trimStr(process.env.REACT_APP_CLIENT_NAME);
  if (fromReact) return fromReact;
  return 'MLB';
}

/**
 * Shorter label for CTAs ("Evaluate for …"). Optional FRONTEND_CLIENT_PROGRAM_LABEL;
 * else strips a trailing "Bluejay(s)" from the display name, else the full display name.
 */
export function getClientProgramLabel() {
  const explicit = trimStr(process.env.REACT_APP_CLIENT_PROGRAM_LABEL);
  if (explicit) return explicit;
  const d = getClientDisplayName();
  const stripped = d.replace(/\s+bluejays?\s*$/i, '').trim();
  return stripped || d;
}

/** Uppercase line under the logo (matches previous “CREIGHTON BLUEJAYS” styling). */
export function getClientBrandLineUpper() {
  return getClientDisplayName().toUpperCase();
}

/** Possessive for short copy, e.g. “Rishi's Ethos”, “Creighton's Ethos”. */
export function getClientPossessive() {
  const name = getClientDisplayName();
  if (!name) return 'Program';
  const endsS = /s$/i.test(name);
  return endsS ? `${name}'` : `${name}'s`;
}

/** Login email field placeholder. */
export function getLoginEmailPlaceholder() {
  let domain = trimStr(process.env.REACT_APP_STAFF_EMAIL_DOMAIN);
  if (domain.includes('@')) {
    domain = domain.split('@').pop() || domain;
  }
  if (domain) return `you@${domain}`;
  return 'you@school.edu';
}
